import initialState from "./initialState";
import { GET_ALL_PRODUCTS_SUCCESS, GET_ALL_PRODUCTS_FAIL} from "../../actions/product/productAction";

export default function productsReducer(state = initialState, action) {

    switch (action.type) {
        case GET_ALL_PRODUCTS_SUCCESS: {

            const products = action.products.map((product) => {
                return {
                    productId: product.id,
                    productName: product.name,
                    productIconUrl: product.icon
                };
            });
            return {...state, products};
        }
        case GET_ALL_PRODUCTS_FAIL: {
            return{...state, errorMessage: "There was an error retrieving all products"};
        }

        default:
            return state;
    }
}
